import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";
import { Provider } from "react-redux";

const limboBaseUrl = typeof window !== 'undefined' ? window.serverData.data.limboBaseUrl : ''; // window is undefined during pre-render
const limboXFunctionsKey = typeof window !== 'undefined' ? window.serverData.data.limboFunctionsKey : '';
const videoVistTypeInternalId = typeof window !== 'undefined' ? window.serverData.data.videoVistTypeInternalId : '';

export const CreateToken = () => {
    const url = tools.buildUrl(limboBaseUrl, '/api/create');

    //var body = {
    //    startDate: startDate,
    //    endDate: endDate,
    //    providers: [
    //        {
    //            id: providerEpicId,
    //            idType: "External"
    //        }]
    //};

    const params = {
        method: "POST",
        //body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": limboXFunctionsKey,
            //"Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.Limbo.CreateToken.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.Limbo.CreateToken.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const getConsumerJWT = (token, participantExternalId, participantName, csnId, epicExternalProviderId) => {
    const url = `${BASE_URL}/api/v1/video/ConsumerToken`;

    const postData = {
        participantId: participantExternalId,
        participantIdType: "External",
        participantRole: "Patient",
        participantName: participantName,
        csnId: csnId,
        epicExternalProviderId: epicExternalProviderId
    };

    const params = {
        method: "POST",
        headers: {
            "Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify(postData)
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT", start, url, null, csnId);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT.Failure", start, url, err, null, csnId);
            return Promise.reject(err);
        });

};

export const SubscribeProvider = (token, providerEpicId) => {
    const url = tools.buildUrl(limboBaseUrl, '/api/rooms/subscribe/ProviderExternalId/' + providerEpicId);

    //var body = {
    //    startDate: startDate,
    //    endDate: endDate,
    //    providers: [
    //        {
    //            id: providerEpicId,
    //            idType: "External"
    //        }]
    //};

    const params = {
        method: "POST",
        //body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": limboXFunctionsKey,
            "Authorization": "Bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.Limbo.SubscribeProvider.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);//.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.Limbo.SubscribeProvider.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const SubscribeDepartment = (token, departmentId) => {
    const url = tools.buildUrl(limboBaseUrl, '/api/rooms/subscribe/DepartmentInternalId/' + departmentId);

    //var body = {
    //    startDate: startDate,
    //    endDate: endDate,
    //    providers: [
    //        {
    //            id: providerEpicId,
    //            idType: "External"
    //        }]
    //};

    const params = {
        method: "POST",
        //body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": limboXFunctionsKey,
            "Authorization": "Bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.Limbo.SubscribeDepartment.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);//.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.Limbo.SubscribeDepartment.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const videoVisitRoomStatus = (token, roomId, isSubscribing) => {  
    const url = tools.buildUrl(limboBaseUrl, `/api/rooms/${isSubscribing?"subscribe":"unsubscribe"}/RoomId/` + roomId);
    const params = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": limboXFunctionsKey,
            "Authorization": "Bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {        
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(`Api.Limbo.VideoVisitRoomStatus.${isSubscribing ? "Subscribing" : "Unsubscribing"}.Post`, start, url, null, roomId);
            return Promise.resolve(response);
        } else {
            logAPI(`Api.Limbo.VideoVisitRoomStatus.${isSubscribing ? "Subscribing" : "Unsubscribing"}.Post.Failure`, start, url, null, roomId);
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI(`Api.Limbo.VideoVisitRoomStatus.${isSubscribing ?"Subscribing":"Unsubscribing"}.Post.Failure`, start, url, err, null, roomId);
        return Promise.reject(err);
    });

};

export const isMobileNumber = (token, phoneNumber) => {
    const url = tools.buildUrl(limboBaseUrl, `/api/v1/phones/${phoneNumber}`);
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": limboXFunctionsKey,
            "Authorization": "Bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        if (response && response.status >= 200 && response.status < 300) {
            logAPI(`Api.Limbo.IsMobileNumber`, start, url, response, phoneNumber);
            return Promise.resolve(response.json());
        } else {
            logAPI(`Api.Limbo.IsMobileNumber.Failure`, start, url, response, phoneNumber);
            return Promise.reject(response.json());
        }
    }).catch(err => {
        logAPI(`Api.Limbo.IsMobileNumber.Failure`, start, url, err, phoneNumber);
        return Promise.reject(err);
    });

};